const DEVICE_LABELS_KEY = 'clickorico.pos.deviceLabels';

function readLabelMap() {
  try {
    const raw = localStorage.getItem(DEVICE_LABELS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeLabelMap(map) {
  try {
    localStorage.setItem(DEVICE_LABELS_KEY, JSON.stringify(map));
  } catch {
    // ignore quota / private mode
  }
}

export function getDeviceFriendlyLabel(deviceId) {
  if (!deviceId) return '';
  const map = readLabelMap();
  const label = map[deviceId];
  return typeof label === 'string' ? label.trim() : '';
}

export function setDeviceFriendlyLabel(deviceId, label) {
  if (!deviceId) return;
  const trimmed = String(label || '').trim().slice(0, 64);
  const map = readLabelMap();
  if (!trimmed) {
    delete map[deviceId];
  } else {
    map[deviceId] = trimmed;
  }
  writeLabelMap(map);
}

export function inferDefaultDeviceLabel() {
  if (typeof navigator === 'undefined') return 'Appareil caisse';
  const ua = navigator.userAgent || '';
  if (/iPad/i.test(ua)) return 'iPad caisse';
  if (/iPhone/i.test(ua)) return 'iPhone caisse';
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return 'Téléphone caisse';
  if (/Android/i.test(ua)) return 'Tablette Android';
  if (/Windows/i.test(ua)) return 'PC comptoir';
  if (/Macintosh/i.test(ua)) return 'Mac caisse';
  return 'Appareil caisse';
}

export function formatDeviceIdShort(deviceId) {
  if (!deviceId || typeof deviceId !== 'string') return '—';
  return `•••• ${deviceId.slice(-8)}`;
}

export function formatDeviceDisplayName(deviceId, fallbackLabel = null) {
  const friendly = getDeviceFriendlyLabel(deviceId) || fallbackLabel;
  if (friendly) return friendly;
  return formatDeviceIdShort(deviceId);
}
